import {createContext} from 'react';

export const CaseContext = createContext(null);
